import { useCallback, useEffect, useState } from 'react';

import { Range } from '@app/shared/components';

import type { ContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { FilterWrapper } from '@pages/Clients/NewClientsList/ui';

export const ServicesSumFilter: ContentType = ({ open, onClose, id }) => {
  const { filtersMap, onChangeServicesSumRange } = useNewClientsListContext();
  const { servicesSumRange } = filtersMap.get(id)!;

  const [localRange, setLocalRange] = useState<{
    from: number | null;
    to: number | null;
  }>({
    from: null,
    to: null,
  });

  const onConfirm = useCallback(() => {
    onChangeServicesSumRange(localRange, id);
    onClose?.();
  }, [id, localRange, onChangeServicesSumRange, onClose]);

  useEffect(() => {
    setLocalRange(open ? servicesSumRange : { from: null, to: null });
  }, [open, servicesSumRange]);

  return (
    <FilterWrapper onConfirm={onConfirm}>
      <Range
        values={localRange}
        onChange={(range) =>
          setLocalRange({ from: range.from ?? null, to: range.to ?? null })
        }
        fromTitle="от"
        toTitle="до"
        min={0}
        max={Number.MAX_SAFE_INTEGER}
      />
    </FilterWrapper>
  );
};
